import { Inject, inject, Injectable } from '@angular/core';
import { FUSE_CONFIG } from '@fuse/services/config/config.constants';
import { merge } from 'lodash-es';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FuseConfigService {
    private _config = new BehaviorSubject(inject(FUSE_CONFIG));

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    constructor(@Inject(FUSE_CONFIG) config: any) {
        // Private
        this._config = new BehaviorSubject(config);
    }

    /**
     * Setter & getter for config
     */
    set config(value: any) {
        let stored =
            JSON.parse(localStorage.getItem('fuse-config')) ||
            this._config.getValue();

        if (value) {
            stored = merge({}, this._config.getValue(), value);
        }

        localStorage.setItem('fuse-config', JSON.stringify(stored));

        this._config.next(stored);
    }

    // eslint-disable-next-line @typescript-eslint/member-ordering
    get config$(): Observable<any> {
        return this._config.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resets the config to the default
     */
    reset(): void {
        // Set the config
        this._config.next(this.config);
    }
}
